import { defineComponent as _defineComponent } from 'vue'
type Props = {
    yesText?: string
    noText?: string
}
type Emits = {
    (e: "yes"): void
    (e: "no"): void
    (e: "close"): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleYesNoModal',
  props: {
    yesText: { default: "Yes" },
    noText: { default: "No" }
  },
  emits: ["yes", "no", "close"],
  setup(__props: any, { expose: __expose }) {
  __expose();





const __returned__ = {  }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})